import { render, staticRenderFns } from "./ProjectCompanyConsentCheck.vue?vue&type=template&id=63acf1fe&scoped=true"
import script from "./ProjectCompanyConsentCheck.vue?vue&type=script&setup=true&lang=ts"
export * from "./ProjectCompanyConsentCheck.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./ProjectCompanyConsentCheck.vue?vue&type=style&index=0&id=63acf1fe&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63acf1fe",
  null
  
)

export default component.exports